<template>
    <Slide right>
        <router-link class="header-nav-link" to="/"><span>Home</span></router-link>
        <router-link class="header-nav-link" to="/our-services/"><span>Our Services</span></router-link>
        <router-link class="header-nav-link" to="/why-use-us/"><span>Why Use Us</span></router-link>
        <router-link class="header-nav-link" to="/testimonials/"><span>Testimonials</span></router-link>
        <router-link class="header-nav-link" to="/contact-us/"><span>Contact Us</span></router-link>
        <a href="tel:07950189260"><span><img src="@/assets/images/phone-1.png" height="15" width="15"><strong class="header-tel"> 07950 189 260</strong></span></a>
    </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {
  name: 'mobile-menu',
  components: {
    Slide
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue